var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dial-track"},[_c('UserTrack',{attrs:{"size":120}}),_c('span',{staticClass:"message",domProps:{"innerHTML":_vm._s(_vm.$userEngine.getDialReckoner)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }